import React from 'react'
import { useFlag } from '@sketch/modules-common'

import AnnotationCommentBox from '../AnnotationCommentBox'
import AnnotationPopoverWrapper from '../AnnotationPopoverWrapper'

import useCreateAnnotation from '../../operations/useCreateAnnotation'
import { Coordinates, DraftAnnotationParameters } from '../../types'

import { useGetDraftAnnotationComment } from '../../hooks'

import { CreateAnnotationMutation } from '@sketch/gql-types'

interface DraftAnnotationPopoverProps {
  coordinates: Coordinates
  parameters: DraftAnnotationParameters
  isViewingLatestVersion: boolean
  onSubmit?: (data: CreateAnnotationMutation) => void
}

const DraftAnnotationPopover = (props: DraftAnnotationPopoverProps) => {
  const { coordinates, parameters, onSubmit, isViewingLatestVersion } = props
  const { shareIdentifier, permanentPageId, permanentArtboardId } = parameters
  const includeHasUnreadComments = useFlag('pages-unread-annotations')

  const [
    draftAnnotationComment,
    setDraftAnnotationComment,
  ] = useGetDraftAnnotationComment()
  const createAnnotation = useCreateAnnotation({
    onCacheUpdated: onSubmit,
    onComplete: onSubmit,
  })

  return (
    <AnnotationPopoverWrapper>
      <AnnotationCommentBox
        shareIdentifier={shareIdentifier}
        showOlderVersionWarning={!isViewingLatestVersion}
        onCommentChange={setDraftAnnotationComment}
        comment={draftAnnotationComment || undefined}
        onCommentSubmit={body => {
          const baseVariables = {
            shareIdentifier,
            body,
            coordinates,
            includeHasUnreadComments,
          }

          if (permanentArtboardId) {
            const subject = {
              type: 'ARTBOARD' as const,
              permanentId: permanentArtboardId,
            }

            createAnnotation({ ...baseVariables, subject }, { permanentPageId })
          } else {
            const subject = {
              type: 'PAGE' as const,
              permanentId: permanentPageId,
            }

            createAnnotation({ ...baseVariables, subject })
          }
        }}
        autoFocus
      />
    </AnnotationPopoverWrapper>
  )
}

export default DraftAnnotationPopover
